// Account-scoped React Query cache keys for the Digital Twin page.
//
// The application owns a single global QueryClient. Including the authenticated
// Cognito subject AND organization in every key guarantees subject A and subject
// B — and two different organizations under the same subject — can never address
// each other's cached farm/telemetry data through that shared cache. A
// subject/org switch remounts the page (see AccountBoundary) but must also not
// reuse subject-less/org-less cached entries.
export interface DigitalTwinQueryKeys {
  farms: readonly [string, string, string, string];
  twin: readonly [string, string, string, string];
  telemetry: readonly [string, string, string, string, string];
}

export const digitalTwinQueryKeys = (
  subjectId: string,
  orgId: string,
  farmId: string,
): DigitalTwinQueryKeys => ({
  farms: ['digital-twin', subjectId, orgId, 'farms'],
  twin: ['digital-twin', subjectId, orgId, farmId],
  telemetry: ['digital-twin', subjectId, orgId, 'iot-telemetry', farmId],
});
